module.exports = __webpack_public_path__ + "img/apple.ee1a4b55.png";